module.exports = __webpack_public_path__ + "static/img/1.6505d2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/9/1.png
// module id = kz0B
// module chunks = 0